import {hotspots} from '../../data/entry.js'
import './hotspot-item.tag'

riot.tag2('hotspot-selector', '<hotspot-item each="{hotspot in hotspots}" data="{hotspot}" css="hotspot-item" active="{parent.hotspots.indexOf(hotspot) === parent.active}" action="{parent.select}"></hotspot-item>', '', 'class="{getClass()}"', function(opts) {

  this.active = null
  this.hotspots = hotspots
  this.select = hotspot => {
    const index = this.hotspots.indexOf(hotspot)
    const active = index === this.active ? null : index
    this.update({active})
    riot.control.trigger(riot.EVT.hideInfobox)
    riot.control.trigger(riot.EVT.mapJumpTo, hotspot)
  }
});



// WEBPACK FOOTER //
// ./src/components/hotspot-selector/hotspot-selector.tag